import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { UtilityService } from '../../../core/services/utility.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-prod-size-colli',
  templateUrl: './prod-size-colli.component.html',
  styleUrls: ['./prod-size-colli.component.css']
})
export class ProdSizeColliComponent implements OnInit {
    prodSizeKeyno;

    prodSizeColliKeyno;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private utility: UtilityService, private modal: ModalService, private datatask: DataTaskService) {
        this.prodSizeKeyno = this.stateService.getStateParams()['prodsize_keyno'];
        this.prodSizeColliKeyno = this.stateService.getStateParams()['prodsizecolli_keyno'];
    }

    private async loadEdit() {
        if (!!this.prodSizeKeyno && !!this.prodSizeColliKeyno) {
            this.edit = (await this.datatask.Post(911, {
                prodsize_keyno: this.prodSizeKeyno,
                prodsizecolli_keyno: this.prodSizeColliKeyno
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(912, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1654, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private recalcVolumeM3() {
        if (!!this.edit) {
            this.edit.volume_m3 = (this.utility.parseNumber(this.edit.height_cm) * this.utility.parseNumber(this.edit.length_cm) * this.utility.parseNumber(this.edit.width_cm)) / 1000000;
        }
    }

    private recalcVolumeM3StackingQty() {
        if (!!this.edit) {
            if (this.edit.input_colli_size === '0') {
                this.edit.volume_m3_stack = this.utility.parseNumber(this.edit.stacking_qty) * this.utility.parseNumber(this.edit.volume_m3);
            }
        }
    }

    private recalcVolumeM3Stack() {
        if (!!this.edit) {
            if (this.edit.input_colli_size === '1') {
                this.edit.volume_m3_stack = (this.utility.parseNumber(this.edit.height_cm_stack) * this.utility.parseNumber(this.edit.length_cm_stack) * this.utility.parseNumber(this.edit.width_cm_stack)) / 1000000;
            }
        }
    }

    public onChanged(_: string | number, id: keyof Edit) {
        switch (id) {
            case 'width_cm':
            case 'height_cm':
            case 'length_cm':
                if (!this.edit) return;

                this.recalcVolumeM3();
                break;
            case 'volume_m3':
            case 'stacking_qty':
                if (!this.edit) return;

                this.recalcVolumeM3StackingQty();
                break;
            case 'width_cm_stack':
            case 'height_cm_stack':
            case 'length_cm_stack':
                if (!this.edit) return;

                this.recalcVolumeM3Stack();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prodsizecolli_keyno: string;
    prodsize_keyno: string;
    colli_content: string;
    width_cm: string;
    height_cm: string;
    length_cm: string;
    volume_m3: string | number;
    stacking: string;
    width_cm_stack: string;
    height_cm_stack: string;
    length_cm_stack: string;
    weight_kg: string;
    stacking_qty: string;
    volume_m3_stack: string | number;
    prodsize_heading: string;
    nbr_of_prodsizecolli: string;
    show_setting: string;
    enable_manual_input_of_volume: string;
    input_colli_size: string;
}
